module.exports = __webpack_public_path__ + "static/media/pushed.749b39ca.svg";